<div class="d-flex align-items-center justify-content-between mb-5">
    <h1 *ngIf="isClient" class="montserrat-light text-gray-500 text-capitalize">my campaigns</h1>
    <h1 *ngIf="!isClient" class="montserrat-light text-gray-500 text-capitalize">all campaigns</h1>
    <div class="d-flex align-items-center" style="display: flex; flex-direction: column">
        <button
            *ngIf="roles.length == 2"
            class="btn btn-lg btn-gray-500 mb-1"
            (click)="onNextRole()"
        >
            Switch to {{ nextRole }}
        </button>
        <div
            class="d-flex align-items-center"
            style="display: flex; flex-direction: row; gap: 10px"
        >
            <form *ngIf="roles.length > 2" [formGroup]="form">
                <mat-form-field class="form-group dark-input">
                    <mat-label>Switch to :</mat-label>
                    <mat-select
                        formControlName="role"
                        panelClass="select-panel-down"
                        [disableOptionCentering]="true"
                        (selectionChange)="onNextRole()"
                    >
                        <mat-option
                            *ngFor="let role of filteredRoles"
                            [value]="role"
                            class="text-capitalize"
                        >
                            {{ role }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </form>
            <a
                *ngIf="!isPreview"
                href="javascript:;"
                class="new-campaign bg-gray-500 px-5 py-3"
                [routerLink]="['/campaign/new']"
            >
                <img
                    src="./assets/images/icons/nav/new-campaign-active.svg"
                    alt="New campaign"
                    title="New campaign"
                    class="mr-2"
                />
                New campaign
            </a>
        </div>
    </div>
</div>
<div class="row">
    <div class="col-12 mt-4">
        <app-campaigns-overview></app-campaigns-overview>
    </div>
</div>
